<template>
<div>
    <a class="product">
        <img :src="info.img">
        <div class="desc">{{info.title}}</div>
    </a>
</div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    props: {
        info: {
            type: Object,
            defautl: {
                img: "",
                desc: ""
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.product {
    display: block;
    box-sizing: border-box;
    // width: 211px;
    background: rgba(133, 189, 255, .05);
    box-shadow: 0 6px 10px 0 #5f656926;
    border-radius: 8px;
    // margin-right: 24px;
    padding: 8px 25px;
    margin: 8px 13px;
    box-sizing: border-box;
    transition: all .2s;
    color: #000;
    border: 1px solid #f4f4f4;
    &:hover{
      border: 1px solid #ddd;
      margin-top: -1px;
    }

    img {
        width: 200px;
        height: 194px;
    }
}

.desc {
    font-size: 14px;
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
